import React from 'react';
import { useAuth } from '../../context/AuthContext';
import { useNavigate } from 'react-router-dom';

const SubscriptionExpired: React.FC = () => {
  const { logout, subscriptionStatus } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center p-4">
      <div className="max-w-md w-full bg-white rounded-lg shadow-lg p-8">
        <div className="text-center">
          <div className="mb-6">
            <svg className="mx-auto h-16 w-16 text-red-500" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z" />
            </svg>
          </div>
          
          <h1 className="text-2xl font-bold text-secondary mb-4">
            {subscriptionStatus ? 'Subscription Expired' : 'No Active Subscription'}
          </h1>
          
          <p className="text-gray-600 mb-6">
            {subscriptionStatus 
              ? 'Your subscription has expired or is inactive. Please contact the administrator to renew your subscription.'
              : 'You do not have an active subscription. Please contact the administrator to get started.'}
          </p>

          {subscriptionStatus && (
            <div className="bg-gray-50 rounded-lg p-4 mb-6 text-left">
              <h3 className="font-semibold text-secondary mb-2">Subscription Details:</h3>
              <div className="space-y-1 text-sm">
                <p><span className="font-medium">Plan:</span> {subscriptionStatus.plan?.planName || 'N/A'}</p>
                <p><span className="font-medium">Status:</span> 
                  <span className={`ml-2 ${subscriptionStatus.isActive ? 'text-green-600' : 'text-red-600'}`}>
                    {subscriptionStatus.isActive ? 'Active' : 'Inactive'}
                  </span>
                </p>
                <p><span className="font-medium">Start Date:</span> {new Date(subscriptionStatus.startDate).toLocaleDateString()}</p>
                <p><span className="font-medium">Expiry Date:</span> {new Date(subscriptionStatus.endDate).toLocaleDateString()}</p>
              </div>
            </div>
          )}

          <div className="space-y-3">
            <button
              onClick={handleLogout}
              className="w-full bg-secondary text-white px-6 py-2 rounded-lg hover:bg-opacity-90 transition"
            >
              Logout
            </button>
            
            <p className="text-sm text-gray-500">
              Need help? Contact your administrator
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SubscriptionExpired;
